var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebViewer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.8545C18.9999 16.5718 18.4185 17.1532 17.7012 17.1533H2.29883C1.58155 17.1532 1.00008 16.5718 1 15.8545V6.79297H19V15.8545ZM17.7012 2C18.4184 2.00016 18.9998 2.5816 19 3.29883V5.67188H1V3.29883C1.00016 2.5816 1.5816 2.00016 2.29883 2H17.7012ZM3.25293 3.26758C2.9414 3.26761 2.68848 3.52053 2.68848 3.83203C2.68855 4.14346 2.94149 4.39548 3.25293 4.39551C3.5644 4.39551 3.8173 4.14348 3.81738 3.83203C3.81738 3.52051 3.56445 3.26758 3.25293 3.26758ZM5.54688 3.26758C5.23532 3.26758 4.98242 3.52051 4.98242 3.83203C4.9825 4.14348 5.2354 4.39551 5.54688 4.39551C5.85821 4.39535 6.11027 4.14339 6.11035 3.83203C6.11035 3.52061 5.85826 3.26774 5.54688 3.26758ZM7.94434 3.26758C7.63282 3.26758 7.37988 3.52051 7.37988 3.83203C7.37996 4.14348 7.63286 4.39551 7.94434 4.39551C8.25575 4.3954 8.50773 4.14342 8.50781 3.83203C8.50781 3.52058 8.25576 3.26769 7.94434 3.26758Z",
    fill: "url(#paint0_linear_6_13996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_13996",
    x1: 10,
    y1: 17.1535,
    x2: 10,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebViewer);
export default __webpack_public_path__ + "static/media/web_viewer.49487087be14cc26d2230fcb7526fac4.svg";
export { ForwardRef as ReactComponent };